<div class="search-component">
  <div class="search-and-filter-row">
    @if (config.showTextSearch) {
      <div class="search-container">
        <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
        <input type="text" [placeholder]="config.textPlaceholder | translate" class="search-input"
          [(ngModel)]="searchTerm" (input)="onSearchInput()">
        @if (searchTerm) {
          <button class="clear-search-btn" (click)="clearSearch()" type="button"
            [title]="'SEARCH.CLEAR' | translate">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        }
      </div>
    }

    @if (config.showTagFilter) {
      <div class="tag-filter-section">
        <div class="tag-filter-container">
          <div class="tag-input-container">
            <input type="text" [(ngModel)]="tagFilterInput" [placeholder]="config.tagPlaceholder | translate"
              class="tag-filter-input" (input)="onTagInputChange()" (focus)="showTagDropdown = true"
              (blur)="onTagInputBlur()" [disabled]="loadingTags">
            <div class="tag-dropdown" [class.show]="showTagDropdown && filteredTagsForInput.length > 0">
              @for (tag of filteredTagsForInput; track tag) {
                <div class="tag-dropdown-item"
                  (mousedown)="selectTagFromDropdown(tag)">
                  <div class="tag-preview-dropdown" [style.background-color]="tag.bg_color" [style.color]="tag.text_color">
                    {{ tag.name }}
                  </div>
                </div>
              }
            </div>
            @if (tagFilterInput) {
              <button class="clear-tag-input" (click)="clearTagFilter()" type="button"
                [title]="'FILTER.CLEAR_TAG' | translate">
                <fa-icon [icon]="faTimes"></fa-icon>
              </button>
            }
          </div>
          @if (loadingTags) {
            <fa-icon [icon]="faSpinner" animation="spin" class="loading-icon"></fa-icon>
          }
        </div>
      </div>
    }

    @if (config.showTypeFilter) {
      <div class="type-filter-section">
        <select class="type-filter-select" [(ngModel)]="selectedTypeFilter" (change)="onTypeFilterChange()">
          <option value="">{{ (config.typePlaceholder || 'SIMULATIONS.TYPE.LABEL') | translate }}</option>
          @for (option of config.typeOptions || []; track option.value) {
            <option [value]="option.value">{{ option.label | translate }}</option>
          }
        </select>
      </div>
    }
  </div>

  @if (hasActiveFilters) {
    <div class="active-filters">
      @if (selectedTypeFilter) {
        <div class="filter-indicator">
          <span>{{ 'SIMULATIONS.TYPE.LABEL' | translate }}: </span>
          <strong>{{ ('SIMULATIONS.TYPE.' + selectedTypeFilter.toUpperCase()) | translate }}</strong>
          <button class="clear-filter-btn" (click)="clearTypeFilter()" [title]="'FILTER.CLEAR_TYPE' | translate">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
      }
      @if (selectedTagFilter) {
        <div class="filter-indicator">
          <fa-icon [icon]="faTag" class="filter-icon"></fa-icon>
          <span>{{ 'FILTER.TAG' | translate }}: </span>
          <strong>{{ selectedTagFilter }}</strong>
          <button class="clear-filter-btn" (click)="clearTagFilter()" [title]="'FILTER.CLEAR_TAG' | translate">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
      }
      @if (searchTerm) {
        <div class="filter-indicator">
          <fa-icon [icon]="faSearch" class="filter-icon"></fa-icon>
          <span>{{ 'FILTER.SEARCH' | translate }}: </span>
          <strong>{{ searchTerm }}</strong>
          <button class="clear-filter-btn" (click)="clearSearch()" [title]="'FILTER.CLEAR_SEARCH' | translate">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
      }
      @if (hasMultipleFilters) {
        <button class="clear-all-filters" (click)="clearAllFilters()"
          [title]="'FILTER.CLEAR_ALL' | translate">
          {{ 'FILTER.CLEAR_ALL' | translate }}
        </button>
      }
    </div>
  }
</div>